export default __webpack_public_path__ + "static/media/icon-instagram.568b5795.svg";